export default __webpack_public_path__ + "static/media/logo.7b3a4bcf.svg";